import AbstractInstaller from "../../core/application/AbstractInstaller";
import ScenarioPlayerEvent from "../scenario/ScenarioPlayerEvent";
import AddPullContentCommand from "./AddPullContentCommand";
import PullContentManager from "./PullContentManager";
import RemovePullContentCommand from "./RemovePullContentCommand";

export default class PullContentInstaller extends AbstractInstaller {

    constructor(injector, commands, mediatorMap) {
        super(injector, commands, mediatorMap);

        injector.mapClass("pullContentManager", PullContentManager, true);
        commands.add(ScenarioPlayerEvent.PULL_DIALOG_AVAILABLE, AddPullContentCommand);
        commands.add(ScenarioPlayerEvent.PULL_DIALOG_UNAVAILABLE, RemovePullContentCommand);

        //startup tasks: none
    }
}